import { Link } from 'react-router-dom';

const UnLoginProfile = () => {
  return (
    <div className="flex flex-col gap-[24.5px]">
      <div className="flex gap-[16px] items-center">
        <div className="w-[54px] h-[54px] rounded-full bg-white" />
        <span className="font-normal text-[#C9C7D1] flex flex-col gap-4">
          <span className="  text-[#C9C7D1] ">
            피벗과 함께 신규 회원을 창출하고,
          </span>
          트레이너들과 소통하며 성장해 보세요.
        </span>
      </div>
      <Link
        to={`/sign`}
        className="w-full border text-[14px] border-solid border-[#4D495A] text-[#C9C7D1] bg-[#2E2B36] rounded-[8px] py-[12px] px-[12px] flex gap-4 items-center justify-center"
      >
        <span>무료로 시작하기</span>
      </Link>
    </div>
  );
};

export default UnLoginProfile;
